import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


    ReactDOM.render(<App />, document.getElementById('root'));
    var timeToWait = 3000; // in miliseconds.
function testFunction() {
    var headerPresent = document.getElementsByClassName('headerClass').length;
    if (headerPresent==0){
        document.getElementById('imagen').style.display="block";
    }
}

 
      setTimeout(function(){ testFunction(); }, timeToWait);
  

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
